import React from 'react';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>HBFC Home Finance</h3>
            <p>Your trusted partner for home financing solutions.</p>
          </div>
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#products">Loan Products</a></li>
              <li><a href="#calculator">Loan Calculator</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Contact Us</h3>
            <p>Email: info@hbfc.com</p>
            <p>Phone: +92-123-456789</p>
            <p>Address: HBFC Building, Main Street, Karachi</p>
          </div>
        </div>
        <div className="copyright">
          <p>&copy; {new Date().getFullYear()} HBFC Home Finance. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 